import React from 'react';
import { useTranslation } from 'react-i18next';
import PasswordChangeForm from './PasswordChangeForm';
import './MfaEnrollment.css'; // Reuse overlay/modal chrome styles

interface ForcePasswordChangeModalProps {
  open: boolean;
  onPasswordChanged: () => void;
  onLogout: () => void;
}

export const ForcePasswordChangeModal: React.FC<ForcePasswordChangeModalProps> = ({
  open,
  onPasswordChanged,
  onLogout,
}) => {
  const { t } = useTranslation();

  if (!open) return null;

  return (
    <div className="mfa-overlay">
      <div className="mfa-modal">
        <div className="mfa-modal-header">
          <div className="mfa-modal-icon mfa-icon-warning">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
              <line x1="12" y1="15" x2="12" y2="17" />
            </svg>
          </div>
          <h2>{t('forcePasswordChange.title')}</h2>
        </div>

        <div className="mfa-modal-content">
          <div className="mfa-forced-notice">
            <p>{t('forcePasswordChange.notice')}</p>
          </div>

          <PasswordChangeForm
            onPasswordChanged={onPasswordChanged}
            submitLabel={t('forcePasswordChange.submitButton')}
            changingLabel={t('forcePasswordChange.changing')}
          />

          <div className="mfa-modal-actions">
            <button className="mfa-button mfa-button-secondary" onClick={onLogout}>
              {t('forcePasswordChange.logout')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
